import { store } from '@wordpress/interactivity';

const storeDef = {
	actions: {
		scrollToTop: () => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		},
	},
};

type Store = typeof storeDef;

store<Store>('scroll-to-top', storeDef);
